import React from 'react'
import ContactUs from '../Components/ContactUs/ContactUs'

const PageFour = () => {
  return (
    <div>
        <ContactUs />
    </div>
  )
}

export default PageFour